import { create } from "zustand"
import { mountStoreDevtool } from "simple-zustand-devtools"
import camelcaseKeysDeep from "camelcase-keys-deep"

import { createSettingsCookie } from "./utils"

const initialData = camelcaseKeysDeep(window.initialData)
const PUBLIC_APP_SUBMISSIONS_LENGTH = 20

export const useStore = create((set) =>({
  // shared data for all types of client
  players: initialData.players,
  setPlayers: (players) => set((state) => ({ players: players })),

  // TEMP PLAYERS_NEW
  playersNew: initialData.playersNew,
  setPlayersNew: (playersNew) => set((state) => ({ playersNew: playersNew })),
  
  brackets: initialData.brackets,
  setBrackets: (brackets) => set((state) => ({ brackets: brackets })),

  nonBracketParticipantPlayerSlugs: initialData.nonBracketParticipantPlayerSlugs,
  setNonBracketParticipantPlayerSlugs: (playerSlugs) => set((state) => ({ nonBracketParticipantPlayerSlugs: playerSlugs })),

  divisions: initialData.divisions,
  divisionSizes: initialData.divisions.map((div) => div.length),
  setDivisions: (divisions) => set(() => ({ divisions: divisions, divisionSizes: divisions.map((div) => div.length) })),

  event: initialData.event,
  setEvent: (event) => set((state) => ({ event: event })),
  setIsLeaderboardShown: (isLeaderboardShown) => set((state) => ({ event: {...state.event, isLeaderboardShown: isLeaderboardShown} })),

  obsState: initialData.obsState,
  setObsState: (obsState) => set((state) => ({ obsState: obsState })),

  layoutSettings: initialData.layoutSettings,

  // TODO: all submissions stuff below is only for OBS. need to at least prefix these variables
  submissions: initialData.submissions,

  submissionsOffset: 0,
  setSubmissionsOffset: (offset) => set((state) => ({ submissionsOffset: offset })),

  // this is called in a setInterval in ObsApp.jsx
  decrementSubmissionsOffset: () => set((state) => {
    const newOffset = state.submissionsOffset - 1 < 0
      ? 0
      : state.submissionsOffset - 1
    
    if (newOffset == 0) {
      window.clearInterval(window.submissionsPollingInterval)
      window.submissionsPollingInterval = null
      // console.log('polling interval cleared')
    }
    
    return ({
      submissions: state.submissions.slice(0, initialData.layoutSettings.obsSubmissionsViewLength + newOffset),
      submissionsOffset: newOffset,
      displayedSubmissions: state.submissions.slice(newOffset, initialData.layoutSettings.obsSubmissionsViewLength + newOffset)
    })
  }),

  displayedSubmissions: initialData.submissions.slice(0, initialData.layoutSettings.obsSubmissionsViewLength),

  handleNewSubmissionBatch: (newSubmissions) => set((state) => {
    let outputSubmissions = [...state.submissions]
    let existingSubmissionIds = state.submissions.map(s => s.id)
    let outputOffset = state.submissionsOffset

    newSubmissions.reverse().forEach(newSubmission => {
      if (!existingSubmissionIds.includes(newSubmission.id)) {
        outputSubmissions.unshift(newSubmission)
        outputOffset += 1
      }
    })

    // const result = {
    //   submissions: outputSubmissions,
    //   submissionsOffset: outputOffset,
    // }
    // console.log({...result})
    return ({
      submissions: outputSubmissions,
      submissionsOffset: outputOffset
    })
  }),

  // public app and control panel
  publicAppSettings: {
    displayedDecimals: 3,
    movementAnimations: true,
    blinkingAnimations: true,
    submissionAnimations: true,
    bingoPointsAnimations: true,
  },
  setPublicAppSettings: (publicAppSettings) => set((state) => {
    const newSettings = {
      ...state.publicAppSettings,
      ...publicAppSettings
    }
    // store these in cookies, then parse cookies on public app first render in PublicApp.jsx
    createSettingsCookie(newSettings)
    return ({ publicAppSettings: newSettings })
  }),

  publicSubmissions: initialData.submissions,

  publicSubmissionsOffset: 0,
  setPublicSubmissionsOffset: (offset) => set((state) => ({ publicSubmissionsOffset: offset })),

  // this is called in a setInterval in PublicApp.jsx
  decrementPublicSubmissionsOffset: () => set((state) => {
    const newOffset = state.publicSubmissionsOffset - 1 < 0
      ? 0
      : state.publicSubmissionsOffset - 1

    if (newOffset == 0) {
      window.clearInterval(window.publicSubmissionsPollingInterval)
      window.publicSubmissionsPollingInterval = null
      // console.log('polling interval cleared')
    }

    return ({
      publicSubmissions: state.publicSubmissions.slice(0, PUBLIC_APP_SUBMISSIONS_LENGTH + newOffset),
      publicSubmissionsOffset: newOffset,
      publicDisplayedSubmissions: state.publicSubmissions.slice(newOffset, PUBLIC_APP_SUBMISSIONS_LENGTH + newOffset)
    })
  }),

  publicDisplayedSubmissions: initialData.submissions.slice(0, PUBLIC_APP_SUBMISSIONS_LENGTH),

  handleNewPublicSubmissionBatch: (newSubmissions) => set((state) => {
    let outputSubmissions = [...state.publicSubmissions]
    let existingSubmissionIds = state.publicSubmissions.map(s => s.id)
    let outputOffset = state.publicSubmissionsOffset

    newSubmissions.reverse().forEach(newSubmission => {
      if (!existingSubmissionIds.includes(newSubmission.id)) {
        outputSubmissions.unshift(newSubmission)
        outputOffset += 1
      }
    })

    // const result = {
    //   submissions: outputSubmissions,
    //   submissionsOffset: outputOffset,
    // }
    // console.log({...result})
    return ({
      publicSubmissions: outputSubmissions,
      publicSubmissionsOffset: outputOffset
    })
  }),

  //public app ONLY
  events: initialData.events,


  // comms tools control panel
  stagedObsState: {
    currentSourceType: null,
    currentPlayerSlug: null,
    currentPage: 1,
    currentChapterName: null
  },
  setStagedObsState: (stagedObsState) => set((state) => ({ stagedObsState: stagedObsState })),
  unstageObsState: () => set((state) => ({
    stagedObsState: {
      currentSourceType: null,
      currentPlayerSlug: null,
      currentPage: null,
      currentChapterName: null
    }
  })),

  setStagedPlayerSlug: (playerSlug) => set((state) => ({
    stagedObsState: {
      currentSourceType: 'player',
      currentPlayerSlug: playerSlug
    }
  })),

  isLoading: false,
  setIsLoading: (isLoading) => set((state) => ({ isLoading: isLoading })),

  hasSentUpdate: false,
  setHasSentUpdate: (hasSentUpdate) => set((state) => ({ hasSentUpdate: hasSentUpdate })),
}))

setTimeout(() => mountStoreDevtool('Store', useStore), 1)
